<div class="flex-column flex-overflow-initial">
    @if (canCreate()) {
        <div class="flex gap">
            <app-text-input
                [form]="form"
                id="newTask"
                class="w-full"
                label="userTasks.newTask"
                (keyup.enter)="addTask($event)"
            ></app-text-input>
            <app-button
                icon="pi-plus"
                [disabled]="!form.value.newTask"
                (clickEvent)="addTask()"
            ></app-button>
        </div>
        <p-divider/>
    }
    <div class="flex-column small">
        @if (tasks()) {
            @for (task of tasks()!.items(); track task.id) {
                <div class="flex gap align-items-center">
                    <app-button
                        icon="pi-circle"
                        [text]="true"
                        severity="secondary"
                        size="small"
                        (clickEvent)="toggleCompleteItem(task, $event)"
                    ></app-button>

                    <div class="flex-1">
                        {{ task.title }}
                    </div>

                    @if (task.folder?.person) {
                        <app-user-chip
                            [user]="$any(task.folder!.person)"
                            [renderType]="UserChipRenderTypeEnum.Client"
                            [sortDetails]="true"
                            (click)="showFolderDetail(task)"
                        ></app-user-chip>
                    }

                    <app-icon
                        icon="pi-pencil"
                        styleClass="font-size-small"
                        (click)="openDetail(task)"
                    ></app-icon>
                </div>
            }

            @if (tasks()!.isEmpty() && !tasks()!.loading()) {
                <app-empty-state></app-empty-state>
            }

            <app-infinite-scroll-load-on-screen
                class="align-self-center"
                [infiniteScroll]="tasks()"
            ></app-infinite-scroll-load-on-screen>
        }
    </div>
</div>
